<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/system_class";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: ["locales", "icon"],
              hideLabelFields: ["locales"]
            }
          ]
        }
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: ["sequence","area"]
            }
          ]
        }
      ]
    }
  })
};
</script>